<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JchlHI/images/cover.jpg?1733085643025" alt="This image is the cover for the book Fearless"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Fearless
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Rafael Yglesias’s novel of trauma, loss, and the bonds formed between victims of catastrophe.</b></p>Max Klein suffers from many anxieties—including a terrible fear of flying—but after surviving a plane crash his worries vanish and he suddenly believes himself invincible. Back home, a psychiatrist puts him in touch with Carla, a victim of the same crash who lost her infant son and suffers from a morbid, debilitating depression. Now Max and Carla begin a relationship that is sometimes intimate, sometimes painful, and perhaps the only path to recovery for both. <i>Fearless</i> is a brilliant portrait of trauma and its aftermath—the shock of loss and the sometimes unexpected ways that people learn to cope with disaster. <i>This ebook features a new illustrated biography of Rafael Yglesias, including rare photos and never-before-seen documents from the author’s personal collection.</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rafael Yglesias
      </h2>
      
      <p class="authorDescription body article"><p>&#160;</p>Rafael Yglesias (b. 1954) is a master American storyteller whose career began with the publication of his first novel, <i>Hide Fox, and All After</i>, at seventeen. Through four decades Yglesias has produced numerous highly acclaimed novels, including <i>Fearless</i>, which was adapted into the film starring Jeff Bridges and Rosie Perez. He lives on New York City&rsquo;s Upper East Side.<p>&#160;</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3b45d8a8